module.exports = __webpack_public_path__ + "static/media/apple.bc25a3a2.svg";